<template>
  <Footer :columns="columns" />
</template>

<script>
import Footer from 'chimera/all/themes/jupiter/components/layout/Footer'

export default {
  components: {
    Footer,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      columns: [
        {
          title: 'Neem contact op',
          links: [
            {
              text: 'Contact',
              to: '/contact-opnemen',
            },
          ],
        },
        {
          title: 'Professionals',
          links: [
            {
              text: 'Aanmelden als pro',
              to: '/contact-opnemen-bedrijf',
            },
          ],
        },
        {
          title: 'Consumenten',
          links: [
            {
              text: 'Informatie over makelaars',
              to: '/informatie-over-makelaars',
            },
          ],
        },
      ],
    }
  },
}
</script>
